import React from 'react';

import Layout from 'components/layout/Layout';
import { PageMetaRepo } from 'domain/repositories';
import { PageMeta } from 'domain/types';
import AboutUs from 'components/aboutUs/AboutUs';

interface Props {
  pageMeta: PageMeta;
}

const AboutUsPage: React.FC<Props> = ({ pageMeta }): JSX.Element => {
  return (
    <Layout pageMeta={pageMeta}>
      <AboutUs />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const pageMeta = await PageMetaRepo.getBySlug('about-us');

  return {
    props: {
      pageMeta
    }
  };
};

export default AboutUsPage;
